<template>
  <div class="mobile-menu-popup" v-if="isOpen">
    <div @click="togglePopup" class="mobile-menu-popup-close">
      &times;
    </div>
    <nav>
      <router-link class="mobile-menu-popup-item m900" to="/for-students">
        <span @click="togglePopup">For students</span></router-link>

      <router-link class="mobile-menu-popup-item m900" to="/for-nerds">
        <span @click="togglePopup">For nerds</span></router-link>

      <!-- <router-link class="mobile-menu-popup-item m900" to="/pricing">
        <span @click="togglePopup">Pricing</span></router-link> -->

      <router-link class="mobile-menu-popup-item m900" to="/how-it-works">
        <span @click="togglePopup">How it works</span></router-link>

      <!-- <router-link class="mobile-menu-popup-item m900" to="/pay">
        <span @click="togglePopup">Pay now</span></router-link> -->
    </nav>
  </div>
</template>

<script>
import EventBus from '@/utils/event-bus'
export default {
  data: function () {
    return {
      isOpen: false
    }
  },
  methods: {
    togglePopup () {
      document.body.classList.toggle('popup-opened')
      this.isOpen = !this.isOpen
    }
  },
  mounted () {
    EventBus.$on('OPEN_MENU_POPUP', () => {
      this.togglePopup()
    })
  }
}
</script>

<style lang="scss">
  $cubic: cubic-bezier(0.4, 0.01, 0.165, 0.99);

  .mobile-menu-popup {
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    padding: 30px 20px;
    font-weight: 900;
    text-transform: uppercase;
    font-size: 36px;
    box-sizing: border-box;
    background-color: #FDCD25;

    .mobile-menu-popup-item {
      line-height: 1.2;
      animation: .3s $cubic both fade-in;
    }

    a {
      color: var(--primary-black);
      display: block;
      text-decoration: none;

      &:last-child {
        color: var(--pay-btn-blue);
      }
    }

    &-close {
      top: 15px;
      left: 20px;
      position: absolute;
    }
  }

@for $i from 1 through 5 {
  .mobile-menu-popup-item {
    &:nth-child(#{$i}) {
      // Delay the animation. Delay increases as items loop.
      animation-delay: $i * (.05s);
    }
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: scale(1.15);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
